import styled from "styled-components";
import {createGlobalStyle} from "styled-components";

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    height: 100%;
    background-color: black;
    color: white;
    font-family: -apple-system, Roboto, sans-serif, serif;
  }
`;

export const PageWrapper = styled.div`
  padding: 48px;
  max-width: 100vw;

  @media (max-width: 768px) {
    padding: 24px; /* Smaller padding on mobile */
  }
`;

export const Heading = styled.h1`
  margin-top: 0;
  margin-bottom: 64px;
  color: white;
  max-width: 80%; /* Make heading responsive */

  @media (max-width: 768px) {
    max-width: 100%;
    font-size: 1.8rem; /* Adjust font size for smaller screens */
  }
`;

export const CenteredContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  width: 90%; /* Use percentage for better responsiveness */

  @media (max-width: 768px) {
    width: 95%; /* Allow content to use more space on smaller screens */
    max-width: 100%;
  }
`;

export const HeadingAccent = styled.span`
  color: #de000d;
`;

export const Paragraph = styled.p`
  margin-bottom: 48px;
  text-align: justify;
  line-height: 1.6;
  @media (max-width: 768px) {
    text-align: left;
  }
`;

export const StyledLink = styled.a`
  color: #de000d;
  font-size: 16px;
  vertical-align: 5%;
  text-decoration: none;
`;

export const DescriptionText = styled.p`
  color: #232129;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 0;
  line-height: 1.25;
`;

export const StyledImage = styled.div`
  margin-top: 42px;
`;

export const StyledGif = styled.img`
  margin-top: 42px;
  width: 100%;
  height: auto; 
  max-width: 100%;
  display: block;
`;

export const InTheCenterContainer = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const StyledLogo = styled.div`
  filter: invert(100%);
`;
